module.exports = __webpack_public_path__ + "static/ideanest-web-2ee7b85c1ea6ddebd49d23e651395f23.jpg";